var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.url)?_c('editor-item-content-image',{attrs:{"src":_vm.value.url},on:{"loaded":function($event){return _vm.$emit('loaded', { element: _vm.value, content: $event })},"loading":function($event){return _vm.$emit('loading', { element: _vm.value, content: $event })}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }